export default "__VITE_ASSET__BoIr_vkM__"